import { createFileRoute } from '@tanstack/react-router';

import { AiUsagePage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/ai-usage')({
  component: AiUsagePage,
});
